import { Text } from '@belong/ui';
import { HOME_DISCLOSURES_STRINGS } from 'accounts/constants/strings/home-disclosures.strings';
import { DateInputFinalFormAdapter } from 'components/DateInput/DateInput';
import Field from 'components/Field/Field';
import { InputFinalFormAdapter } from 'components/Input/Input';
import { maskMMDDYYYY, unmaskMMDDYYYY } from 'components/Input/masks';
import {
  MEDIA_LABEL,
  NewMediaUploadAdapter,
} from 'components/NewMediaUploader/NewMediaUploader';
import {
  GRID_SIZE,
  SELECTOR_TYPES,
  SelectorFinalFormAdapter,
} from 'components/Selector/Selector';
import { Col, Row } from 'forkedlibraries/react-bootstrap';
import {
  composeValidators,
  dateValidationMMDDYY,
  required,
} from 'utils/validation';

type HouseCodeViolationRIFieldsProps = {
  name: string;
};

export function HouseCodeViolationRIFields({
  name,
}: HouseCodeViolationRIFieldsProps) {
  return (
    <div>
      <Row>
        <Col xs={24} sm={12} md={6}>
          <Field
            name={`${name}.dateNoted`}
            component={DateInputFinalFormAdapter}
            mask={maskMMDDYYYY}
            unmask={unmaskMMDDYYYY}
            placeholder={HOME_DISCLOSURES_STRINGS['housing_code_ri.date_noted']}
            validate={composeValidators(required, dateValidationMMDDYY)}
          />
        </Col>
        <Col xs={24} sm={12} md={12}>
          <Text className="mt-sm block font-semibold">
            {HOME_DISCLOSURES_STRINGS['housing_code_ri.status']}
          </Text>
          <Field
            name={`${name}.status`}
            component={SelectorFinalFormAdapter}
            validate={required}
            type={SELECTOR_TYPES.SMALLTEXTBUTTON}
            grid
            gridSize={GRID_SIZE.MEDIUM}
            buttons={[
              {
                label: HOME_DISCLOSURES_STRINGS['housing_code_ri.status_open'],
                key: 'Open',
              },
              {
                label:
                  HOME_DISCLOSURES_STRINGS[
                    'housing_code_ri.status_repair_scheduled'
                  ],
                key: 'RepairScheduled',
              },
              {
                label:
                  HOME_DISCLOSURES_STRINGS['housing_code_ri.status_remedied'],
                key: 'Remedied',
              },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12} md={12}>
          <Field
            name={`${name}.issuingAuthority`}
            component={InputFinalFormAdapter}
            placeholder={
              HOME_DISCLOSURES_STRINGS['housing_code_ri.issuing_authority']
            }
            validate={required}
          />
        </Col>
        <Col xs={24} sm={12} md={12}>
          <Field
            name={`${name}.violationCondition`}
            component={InputFinalFormAdapter}
            placeholder={
              HOME_DISCLOSURES_STRINGS['housing_code_ri.violation_condition']
            }
            validate={required}
          />
        </Col>
      </Row>
      <div className="mt-lg">
        <Field
          name={`${name}.file`}
          component={NewMediaUploadAdapter}
          mediaLabel={MEDIA_LABEL.FILE_UPLOAD}
          customLabel={HOME_DISCLOSURES_STRINGS['housing_code_ri.file_label']}
          disableWebcam
          cleanOnMediaChange
          isSingleMedia
        />
      </div>
    </div>
  );
}
